import React from 'react'
import { Logo } from '../../images'

const Sidenav = () => {
    const dashboard_links = [{name: 'Dashboard', route:'/home', isOpen:false}, 
                             {name: 'Announcements', route:'/announcements', isOpen:false}, 
                             {name:'Settings', route:'/settings', isOpen:false}]
    return (
        
        <div className='p-6 h-screen overflow-y-auto bg-gray-800'>
            <div className='flex flex-col gap-6'>
                {/* logo */}
                <div className='flex gap-2 items-center'>
                    <img src={Logo} className="h-8 w-8" alt='Logo' />
                    <a href='#' className='no-underline '><p className='hover:text-gray-200 text-xl text-white'><span className='text-white'>Oodles </span>Internship</p></a>
                </div>
                {/* menu items */}
                <div className='mt-6'>
                    <div className='flex flex-col gap-2 bg-gray-500 px-2 py-4 w-full rounded-sm'>
                        {dashboard_links.map((link, index)=>(
                            <a className='bg-gray-600 rounded-md w-full text-center text-gray-50 py-1 px-2  flex justify-between items-center' key={index} href={link.route}>{link.name}
                                {/* <span>
                                    <svg 
                                        className={`w-4 h-4 ml-2 transform transition-transform duration-300 ${link.isOpen ? 'rotate-180' : ''}`} 
                                        xmlns="http://www.w3.org/2000/svg" 
                                        fill="none" 
                                        viewBox="0 0 24 24" 
                                        stroke="currentColor"
                                    >
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                                    </svg>
                                </span> */}
                            </a>
                        ))}
                    </div>
                </div>

                {/* Footer */}
                <div></div>
            </div>
        </div>
    )
}

export default Sidenav